import React,{useState,useEffect} from 'react'
import classes from './SelectPack.module.css'
import Navbar from '../Components/Navbar'
import { base_url, check_api, script_api, Subscribe_api } from '../Services/Apis'
import axios from 'axios'
import ConfirmationModal from '../Components/ConfirmationModal'
import Cookies from 'js-cookie'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigation } from 'react-router-dom'
import {useNavigate} from 'react-router-dom'
// import { v4 as uuidv4 } from 'uuid';

const SelectPack = () => {

    const [pack,setPack] = useState('Daily')
    const [loading,setLoading] = useState(false)
    const [modal,setModal] = useState(false);

    const [subscribeLoading,setSubscribeLoading] = useState(false)

    const params = new URLSearchParams(window.location.search)
    const extId = params.get('ext_ref') 
    let number = params.get('msisdn')

    // console.log(number)

    // useEffect(()=>{
    //   if(number == ''){
    //     number = Cookies.get('number')
    //   }
    // },[number])

    // const number = Cookies.get('number')

    const handleCloseModal = ()=>{
      setModal(false)
    }




    const getScript=async()=> {
      setLoading(true);

      try {
        
        const getScript = await axios.get(`${script_api}?tid=${extId}&msisdn=${number}`)
        // const getScriptURL = `${ENDPOINT_URL}?applicationId=193&countryId=207&requestId=${evinaRequestId}`;
        console.log("script url--- ", getScript.data);
        // const response = await axios.get(getScriptURL.data);

        // if (!response.ok) {
        //   throw new Error(
        //     `Failed to fetch script: ${response.status} ${response.statusText}`
        //   );
        // }

        const scriptContent = await getScript.data.s;
        console.log("response----- " + scriptContent);
        // setAntiFrauduniqid(scriptContent["AntiFrauduniqid"]);

        console.log("response " + scriptContent[100]);

        if (scriptContent) {
          let top_head = document.getElementsByTagName("head")[0];
          let anti_script = document.createElement("script");

          anti_script.innerHTML = scriptContent;
          top_head.insertBefore(anti_script, top_head.firstChild);

          var event = new Event("DCBProtectRun");
          // console.log(event);
          document.dispatchEvent(event);
          document.addEventListener("gateway-load", (event) => {
            //Enable form submission
            // setScriptLoaded(true);
            console.log(event, "EVENT LOADED");
            setModal(true)
          });
        }





      } catch (error) {
        console.error("Error fetching script", error);
      } finally {
        setLoading(false);
      }
    }


    useEffect(()=>{
      getScript()
    },[])


    const navigate = useNavigate()

    const getSubData=async(e)=>{

      e.preventDefault()
      setSubscribeLoading(true)
              try{
      
                  const data ={
              "msisdn":number,
              "tid":extId,
              "pack":pack == 'Daily' ? "SUB_DAILY" : pack == 'Weekly' ? "SUB_WEEKLY" : "SUB_MONTHLY",
              "mode":"WAP_API",
              "service":"FunnyBone"
          }
      
          // const response = await axios.get(`${check_api}`);
          // console.log(response,'response of check api --------')
      
      
        
      
      
          // console.log(response.data);
          // if(response.data.ft == 1000){
              const res = await axios.post(`${Subscribe_api}`,data)
              console.log(res.data)
              if(res.data == 'success' || res.data == 'SUCCESS'){
                Cookies.set('sub_number',number,{ expires: 1 })
                navigate(`/check?ani=${number}&ext_ref=${extId}`)
              // }
              // else{
              //   toast.error(res.data);
              //   navigate(`/progress?msisdn=${number}`)
              //   // handleCloseModal()
              // }
             
          }
          else if(res.data == 'SUBSCRIPTION_IN_PROGRESS'){
              // toast.error(res.data)

              navigate(`/progress?msisdn=${number}`)
              
          }
          else{
            handleCloseModal();
            navigate(`/subscribe?ext_ref=${extId}`)
          }
          setSubscribeLoading(false)
    
      }
              catch(err){
                  console.log(err)
                  // toast.error(err.response.data)
                  navigate(`/subscribe?ext_ref=${extId}`)
              }
              setSubscribeLoading(false)

          }






    const handleSubmit=(e)=>{
      e.preventDefault()
      // getScript()
// const getScriptURL = await axios.get(`${base_url}/FunnyBoneMtn

      setModal(true)
    }





  return (
    <>
    <Navbar/>
    <div className={classes.container}>
    <div className={classes.title}>
    Subscribe The Services  
    </div>
    <hr className='text-gray-500'/>
    <div className={classes.select}>
    <div className={`${classes.card} ${pack == 'Daily' && classes.active}`} onClick={()=>setPack('Daily')}>
   {
    pack == 'Daily'
    && 
     <div className={classes.tick}>
    <i className='pi pi-check' style={{color:'black',fontSize:'1.25rem',fontWeight:'bold'}}></i>
    </div>
   }
    <p  className='font-bold'>DAILY SUBSCRIPTION</p>
    <p className='text-red-700 font-bold'>K2</p>
    </div>
    <div className={`${classes.card} ${pack == 'Weekly' && classes.active}`} onClick={()=>setPack('Weekly')}>
    {
    pack == 'Weekly'
    && 
     <div className={classes.tick}>
    <i className='pi pi-check' style={{color:'black',fontSize:'1.25rem',fontWeight:'bold'}}></i>
    </div>
   }
    <p  className='font-bold'>WEEKLY SUBSCRIPTION</p>
    <p className='text-red-700 font-bold'>K5</p>
    </div>
    <div className={`${classes.card} ${pack == 'Monthly' && classes.active}`} onClick={()=>setPack('Monthly')}>
    {
    pack == 'Monthly'
    && 
     <div className={classes.tick}>
    <i className='pi pi-check' style={{color:'black',fontSize:'1.25rem',fontWeight:'bold'}}></i>
    </div>
   }
    <p className='font-bold'>MONTHLY SUBSCRIPTION</p>
    <p className='text-red-700 font-bold'>K15</p>
    </div>
    </div>
    <hr className='text=gray-500'/>

    <form className={classes.submit_div} onSubmit={handleSubmit}>
    <p >We will never share your mobile number unless you allow us to do so. View our <span className='text-[#ffa20e]'>Terms & Conditions</span></p>
    <button type='submit' className={classes.btn}  >
    SUBSCRIBE NOW
    </button>
    </form>
    <ConfirmationModal subscribeLoading={subscribeLoading} visible={modal} handleCloseModal={handleCloseModal}   getSubData={getSubData} />
    {/* <ToastContainer/> */}
    </div>
    </>
  )
}

export default SelectPack
